<template>
    <div class="snippet-preview-wrapper border rounded" style="background: #fafafa; min-height: 200px;">
        <div v-if="loading" class="d-flex align-items-center justify-content-center" style="height: 200px;">
            <b-spinner variant="primary" />
        </div>
        <div v-else-if="error" class="text-danger p-2">
            <small>미리보기 오류: {{ error }}</small>
        </div>
        <div v-else-if="!content" class="d-flex align-items-center justify-content-center text-muted" style="height: 200px;">
            <small>내용을 입력하면 미리보기가 표시됩니다.</small>
        </div>
        <iframe
            v-else
            ref="iframe"
            class="snippet-preview-iframe"
            :srcdoc="renderedHtml"
            sandbox="allow-same-origin"
            @load="adjustHeight"
        />
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
export default {
    name: 'SnippetPreview',
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            renderedHtml: '',
            loading: false,
            error: null,
        };
    },
    watch: {
        content: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.renderedHtml = '';
                    return;
                }
                this.renderPreview(val);
            }
        }
    },
    methods: {
        async renderPreview(content) {
            this.loading = true;
            this.error = null;
            try {
                const resp = await this.$axios.post('/mail/render-preview', { template: content });
                this.renderedHtml = resp.data.html || resp.data;
            } catch (e) {
                this.error = getErrorMessage(e, '렌더링 실패');
            } finally {
                this.loading = false;
            }
        },
        adjustHeight() {
            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentDocument) return;
            const h = iframe.contentDocument.documentElement.scrollHeight;
            iframe.style.height = (h + 16) + 'px';
        },
    }
};
</script>

<style scoped>
.snippet-preview-iframe {
    width: 100%;
    border: 0;
    background: #fff;
    min-height: 200px;
    display: block;
}
</style>
